import React, {Fragment} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";

import {ROUTES} from "../../../../../routes";
import LookWizard from "../../../lookNavigation/lookMain/lookWizard/lookWizard";
import {setWizardActiveStep} from "../../../../../actions/wizardFunctions";
import {getActiveWizardItem, getCurrentGroups} from "../../../lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import GroheWizardContent from "./groheWizardContent";
import LookWizardContentButtons from "../../../lookNavigation/lookMain/lookWizard/lookWizardContentButtons";
import GroheWizardSelectedSteps from "./groheWizardSelectedSteps";

const GroheWizard = (props) => {

  const {shopPageOpened, sectionOpened, isMobile, wizardItem} = props;

  return (
    <Fragment>
      <section className={"grohe-section grohe-wizard"
        + (sectionOpened ? " grohe-section--opened" : "")
        + (shopPageOpened ? " grohe-section--shop" : "")
      }>
        {wizardItem ? (
          <LookWizard>
            <div className={"grohe-container " + (isMobile ? " grohe-container--full-height" : " grohe-container--no-top-padding")}>
              <GroheWizardContent/>
              {isMobile ? null : (
                <Fragment>
                  <LookWizardContentButtons/>
                  <GroheWizardSelectedSteps/>
                </Fragment>
              )}
            </div>
          </LookWizard>
        ) : null}
      </section>
      {isMobile ? <GroheWizardSelectedSteps isMobile={true}/> : null}
    </Fragment>
  )
};

const mapStateToProps = (store, ownProps) => {
  const {wizardActiveStep, wizardList, wizardActiveItem, wizardShowFeatureSection, wizardSelectedValues} = store.wizardState;
  const {shopPageOpened} = store.shopState;
  const {isMobile} = store.serverState;

  const {location} = ownProps;
  const showWizard = (shopPageOpened && wizardActiveItem) || (location && location.pathname && location.pathname.includes(ROUTES.wizard));

  const wizardItem = wizardActiveItem || getActiveWizardItem(wizardList, location);

  let sectionOpened = shopPageOpened ? wizardActiveItem : showWizard && wizardItem;
  if (isMobile && wizardActiveStep > -1) {
    const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
    if (currentGroups.length > 0) {
      sectionOpened = !!wizardShowFeatureSection
    }
  }

  return {
    shopPageOpened,
    sectionOpened,
    isMobile,
    wizardItem,
  };
};

const mapDispatchToProps = {
  setWizardActiveStep,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroheWizard)
)
